export { default } from './Breadcrumb';
export type { BreadcrumbVariant, BreadcrumbLinkVariant } from './Breadcrumb';
